import http from "../plugins/axios";
const BASE_URI = "";

export default {
    login(data) {
        return http.post(`${BASE_URI}/login_check`, data);
    }
};
